import React from 'react'
import './icon.scss'

interface IconProps {
    className: string
    alt: string
  }
  
  const Icon: React.FC<IconProps> = ({ className, alt }) => {
    return <i className={`icon ${className}`} aria-label={alt} />
  }
  
  export default Icon
